export default __webpack_public_path__ + "static/emma-video-df72f6489a6fdc74e184ae103daf6463.mp4";